import type { SessionUser } from '../types/api'

export const SHARED_WORKSPACE_ID = '11111111-1111-4111-8111-111111111111'
export const SHARED_WORKSPACE_NAME = 'MiaoForm Internal Workspace'
export const SHARED_WORKSPACE_SLUG = 'miaoform'
export const SHARED_WORKSPACE_PLAN: SessionUser['plan'] = 'pro'
